import { HUImage } from "@modules/types/imageTypes"
import { AnimatePresence, motion } from "motion/react"
import { CSSProperties, useState } from "react"
import { Blurhash } from "react-blurhash"

type ImageType = Omit<HUImage, "blurHash"> & {
  blurHash?: string
}

type Props = {
  image?: ImageType
  width: string
  height: string
  style?: CSSProperties
  children?: React.ReactNode
  className?: string
} & React.HTMLAttributes<HTMLDivElement>

export const HUBackgroundImageView: React.FC<Props> = ({
  image,
  width,
  height,
  className,
  style,
  children,
  ...props
}) => {
  const [isImageInCache, setIsImageInCache] = useState<boolean>(false)

  const handleLoad = () => {
    setIsImageInCache(true)
  }

  return (
    <div
      style={{
        backgroundImage: image && isImageInCache ? `url(${image.path})` : undefined,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        width,
        height,
        ...style,
      }}
      {...props}
      className={className}
    >
      {!isImageInCache && image?.blurHash && (
        <AnimatePresence>
          <motion.div
            animate={{ opacity: [0.4, 0.8, 0.4] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            exit={{ opacity: 0 }}
            style={{ position: "absolute" }}
          >
            <Blurhash hash={image.blurHash} style={{ flex: 1, width, height }} />
          </motion.div>
        </AnimatePresence>
      )}
      {image && <img src={image.path} alt="" onLoad={handleLoad} style={{ display: "none" }} />}
      {(isImageInCache || !image) && children}
    </div>
  )
}
